import React, { PropsWithChildren, SetStateAction, useContext, useEffect, useRef, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { Pressable, ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { Image } from 'expo-image';

const styles = StyleSheet.create({
});

interface PasswordRequirementsButtonProps {
};

export function PasswordRequirementsButton({
}: PasswordRequirementsButtonProps) : React.ReactNode {

  const ref = useRef<React.ComponentRef<typeof Pressable>>(null);

  useEffect(() => {
    if (AppUtilities.isWeb() && ref.current) {
      // TODO: https://github.com/necolas/react-native-web/issues/2828
      if (typeof (ref.current as any).setAttribute === 'function') {
        (ref.current as any).setAttribute("title", "Show password requirements");
      }
    }
  }, [ref]);

  return (
  <Pressable
    onPress={() => AppUtils.showInformationalToast("Passwords must be at least 4 characters. No other requirements.")}
    hitSlop={AppConsts.HIT_SLOP_SMALL}
    ref={ref}
  >
    <Image
      style={AppConstants.STYLES.imageInfoSmall}
      source={require('@/assets/images/minis/info.png')}
      alt={"Show password requirements"}
      accessibilityLabel={"Show password requirements"}
    />
  </Pressable>
  );
};
